import { render, staticRenderFns } from "./client-info.vue?vue&type=template&id=f1ffee28&scoped=true&lang=pug&"
import script from "./client-info.vue?vue&type=script&lang=ts&"
export * from "./client-info.vue?vue&type=script&lang=ts&"
import style0 from "./client-info.vue?vue&type=style&index=0&id=f1ffee28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ffee28",
  null
  
)

export default component.exports